import DatetimePicker from './src/main'

DatetimePicker.install = function (Vue) {
    Vue.components(DatetimePicker.name, DatetimePicker)
}

export default DatetimePicker